module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-31.0f5eadbd.png";